import React from "react";
import { Outlet } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";

export default function Layout() {
  useCrumb("/users/", {
    to: `/users`,
    text: "Users",
  });
  return <Outlet />;
}
